import { render } from "./LoadingScreen.vue?vue&type=template&id=403e281c&scoped=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=403e281c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403e281c"]])

export default __exports__